<div class="date-buttons">
  @for (isoIdx of displayOrder; track isoIdx) {
    <cs-button
      small
      square
      [toggle]="selectedDays[isoIdx]"
      [label]="dayLabels[isoIdx]"
      [attr.e2e-locator]="'day-button-' + isoIdx"
      (click)="toggleDay(isoIdx)">
    </cs-button>
  }
</div>
